var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { StyledDialog } from '../StyledDialog/StyledDialog';
import { OptionRoyaltyRestrictionDetails } from './OptionRoyaltyRestrictionDetails';
export function OptionRoyaltyRestrictionModal(_a) {
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, isShowRestriction = _a.isShowRestriction, rowFeature = _a.rowFeature;
    var titleText = isShowRestriction ? 'Option Restriction' : 'Option Royalty';
    return (_jsx(StyledDialog, __assign({ isOpen: isOpen, setIsOpen: setIsOpen, sizeProps: { width: '75%' }, rowGap: "16px", padding: "28px", title: titleText }, { children: _jsx(OptionRoyaltyRestrictionDetails, { rowFeature: rowFeature, isShowRestriction: isShowRestriction }) })));
}
